import React, { useState, useEffect } from "react";
import axios from "../api/axios";

function AddInstal() {
  const [formData, setFormData] = useState({
    nombre: "",
    direccion: "",
    telefono: "",
    productos: [{ referencia: "", descripcion: "", cantidad: 1 }],
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [suggestions, setSuggestions] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleProductChange = async (index, field, value) => {
    const updatedProducts = [...formData.productos];

    if (field === "referencia") {
      // Actualiza temporalmente el input
      updatedProducts[index].descripcion = value;
      updatedProducts[index].referencia = "";

      setFormData({ ...formData, productos: updatedProducts });

      // Si el usuario escribe más de 1 carácter, buscar sugerencias
      if (value.length > 1) {
        try {
          const { data } = await axios.get(`/api/productInstall?q=${value}`);
          setSuggestions((prev) => ({ ...prev, [index]: data }));
        } catch (error) {
          console.error("Error buscando productos:", error);
        }
      } else {
        setSuggestions((prev) => ({ ...prev, [index]: [] }));
      }
    } else {
      updatedProducts[index][field] = value;
      setFormData({ ...formData, productos: updatedProducts });
    }
  };

  // ✅ Cerrar sugerencias al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".autocomplete-container")) {
        setSuggestions({});
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const selectSuggestion = (index, referencia, descripcion) => {
    const updatedProducts = [...formData.productos];
    updatedProducts[index].referencia = referencia; // solo referencia
    updatedProducts[index].descripcion = descripcion; // descripción separada
    setFormData({ ...formData, productos: updatedProducts });
    setSuggestions((prev) => ({ ...prev, [index]: [] }));
  };

  const addProductRow = () => {
    setFormData({
      ...formData,
      productos: [
        ...formData.productos,
        { referencia: "", descripcion: "", cantidad: 1 },
      ],
    });
  };

  const removeProductRow = (index) => {
    const updatedProducts = formData.productos.filter((_, i) => i !== index);
    setFormData({ ...formData, productos: updatedProducts });
  };

  const handleSubmit = async () => {
    try {
      await axios.post("/api/addInstal", formData);
      alert("Instalación añadida correctamente");
      setFormData({
        nombre: "",
        direccion: "",
        telefono: "",
        productos: [{ referencia: "", descripcion: "", cantidad: 1 }],
      });
      setShowModal(false);
    } catch (error) {
      console.error(error);
      setErrorMessage("Error al guardar la instalación");
    }
  };

  return (
    <div className="grid grid-cols-4 gap-4 min-h-[calc(100vh-6rem)]">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setShowModal(true);
        }}
        className="col-span-3 bg-secondary-100 p-4 rounded-lg"
      >
        <h1 className="p-4 font-bold text-xl uppercase">Nueva Instalación</h1>

        {/* Nombre y Teléfono */}
        <div className="grid grid-cols-12 px-4 text-xs font-bold uppercase mt-2">
          <div className="col-span-7 me-3">
            <input
              id="nombre"
              type="text"
              value={formData.nombre}
              onChange={handleChange}
              placeholder="Nombre / Empresa"
              className="w-full p-2 bg-secondary-900 rounded-lg"
              required
            />
          </div>
          <div className="col-span-3 me-3">
            <input
              id="telefono"
              type="text"
              value={formData.telefono}
              onChange={handleChange}
              placeholder="Teléfono"
              className="w-full p-2 bg-secondary-900 rounded-lg"
              required
            />
          </div>
        </div>

        {/* Dirección */}
        <div className="grid grid-cols-12 px-4 text-xs font-bold uppercase mt-2">
          <div className="col-span-7 me-3">
            <input
              id="direccion"
              type="text"
              value={formData.direccion}
              onChange={handleChange}
              placeholder="Dirección"
              className="w-full p-2 bg-secondary-900 rounded-lg"
              required
            />
          </div>
          <div className="col-span-3 me-3">
            <input
              id="poblacion"
              type="text"
              value={formData.poblacion || ""}
              onChange={handleChange}
              placeholder="Población"
              className="w-full p-2 bg-secondary-900 rounded-lg"
            />
          </div>
        </div>

        {/* Productos */}
        <h3 className="p-4 font-bold text-xl">Productos</h3>
        {formData.productos.map((prod, index) => (
          <div
            key={index}
            className="grid grid-cols-12 px-4 text-xs font-bold uppercase mt-2 relative"
          >
            {/* Input referencia con autocompletado */}
            <div className="col-span-7 me-3 autocomplete-container">
              <input
                type="text"
                placeholder="Producto"
                value={
                  prod.referencia && prod.descripcion
                    ? `${prod.referencia} - ${prod.descripcion}`
                    : prod.descripcion || prod.referencia
                }
                onChange={(e) =>
                  handleProductChange(index, "referencia", e.target.value)
                }
                className="w-full p-2 bg-secondary-900 rounded-lg"
                required
              />

              {suggestions[index] && suggestions[index].length > 0 && (
                <ul className="absolute z-10 bg-secondary-900 rounded-lg mt-1 w-full max-h-40 overflow-y-auto shadow-lg">
                  {suggestions[index].map((item) => (
                    <li
                      key={item.referencia}
                      className="cursor-pointer hover:bg-secondary-700 p-2 text-xs font-bold uppercase"
                      onClick={() =>
                        selectSuggestion(
                          index,
                          item.referencia,
                          item.descripcion
                        )
                      }
                    >
                      {item.referencia} - {item.descripcion}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Input cantidad */}
            <div className="col-span-3 me-3 flex items-center">
              <input
                type="number"
                placeholder="Cantidad"
                value={prod.cantidad}
                min="1"
                onChange={(e) =>
                  handleProductChange(index, "cantidad", e.target.value)
                }
                className="w-full p-2 bg-secondary-900 rounded-lg"
                required
              />
            </div>

            {/* Botones + y - */}
            <div className="col-span-2 flex space-x-2">
              <button
                type="button"
                onClick={addProductRow}
                className="bg-green-500 text-white font-bold px-3 py-1 rounded hover:bg-green-600"
              >
                +
              </button>
              {formData.productos.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeProductRow(index)}
                  className="bg-red-500 text-white font-bold px-3 py-1 rounded hover:bg-red-600"
                >
                  -
                </button>
              )}
            </div>
          </div>
        ))}

        {/* Error */}
        {errorMessage && (
          <div className="bg-red-500 text-white p-2 rounded mb-4 text-sm font-semibold">
            {errorMessage}
          </div>
        )}

        {/* Botón enviar centrado */}
        <div className="flex justify-center items-center">
          <button
            type="submit"
            className="bg-secondary-900 font-bold uppercase py-2 px-6 mt-4 text-sm rounded-lg hover:text-black"
          >
            Guardar Instalación
          </button>
        </div>
      </form>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="text-black bg-white p-6 rounded-lg w-130">
            <h2 className="text-lg font-bold mb-4">Resumen de Instalación</h2>
            <p>
              <strong>Nombre:</strong> {formData.nombre}
            </p>
            <p>
              <strong>Teléfono:</strong> {formData.telefono}
            </p>
            <p>
              <strong>Dirección:</strong> {formData.direccion}
            </p>
            <h3 className="mt-4 font-semibold">Productos:</h3>
            <ul className="list-disc pl-5">
              {formData.productos.map((prod, i) => (
                <li key={i}>
                  {prod.referencia} {prod.descripcion} - Cantidad:{" "}
                  {prod.cantidad}
                </li>
              ))}
            </ul>
            <div className="flex text-center space-x-2 mt-4">
              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
              >
                Cancelar
              </button>
              <button
                onClick={handleSubmit}
                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddInstal;
